<mat-autocomplete #auto="matAutocomplete" (optionSelected)="onItemSelected($event)" [displayWith]="displayFunc">
  <mat-optgroup label="Airports" *ngIf="showAiports()">
    <mat-option *ngFor="let result of airportResults$ | async" class="autocomplete__result" [value]="result">
      <span class="autocomplete__airport" [innerHTML]="getAirportText(result) | highlight: query"></span>
      <span class="autocomplete__city-state" [innerHTML]="getCityStateText(result) | highlight: query"></span>
    </mat-option>
    <mat-option *ngIf="sanitizedQuery.length >= 3 && isString(query) && currentSearchTab != searchFormType.FuelPrice" class="autocomplete__result" [value]="query">
      Search for Airport and City names containing "{{ query }}"
    </mat-option>
  </mat-optgroup>
  <mat-optgroup label="Locations" *ngIf="showGoogle()">
    <mat-option *ngFor="let result of googleResults$ | async" class="autocomplete__result" [value]="result">
      <span class="autocomplete__airport" [innerHTML]="result.description | highlight: query"></span>
      <span class="autocomplete__city-state" [innerHTML]="getCityText()"></span>
    </mat-option>
    <mat-option *ngFor="let result of usStateResults$ | async" class="autocomplete__result" [value]="result">
      <span class="autocomplete__airport" [innerHTML]="result.name | highlight: query"></span>
      <span class="autocomplete__city-state" [innerHTML]="getStateTerritoryText()"></span>
    </mat-option>
  </mat-optgroup>
  <mat-optgroup label="Locations" *ngIf="showInternational()">
    <mat-option *ngFor="let result of internationalCityResults$ | async" class="autocomplete__result" [value]="result">
      <span class="autocomplete__airport" [innerHTML]="result.description | highlight: query"></span>
      <span class="autocomplete__city-state" [innerHTML]="getInternationalText(result)"></span>
    </mat-option>
  </mat-optgroup>
</mat-autocomplete>
